export default __webpack_public_path__ + "static/media/Contrast.e4a16267.svg";